import { apiClient } from './client'

export interface StatusComponent {
  id: string
  key: string
  name: string
  description: string
  position: number
}

export type StatusComponentInput = Omit<StatusComponent, 'id'>

/** A listed component plus when an incident last carried the match label with its key (90-day window). */
export interface ListedStatusComponent extends StatusComponent {
  last_matched_at: string | null
}

export async function listStatusComponents(): Promise<{ components: ListedStatusComponent[]; match_label: string }> {
  return apiClient.get('/api/v1/status-components')
}

export async function createStatusComponent(input: StatusComponentInput): Promise<StatusComponent> {
  return apiClient.post('/api/v1/status-components', input)
}

export async function updateStatusComponent(id: string, input: StatusComponentInput): Promise<StatusComponent> {
  return apiClient.patch(`/api/v1/status-components/${id}`, input)
}

export async function deleteStatusComponent(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/status-components/${id}`)
}

export async function setStatusComponentMatchLabel(matchLabel: string): Promise<void> {
  await apiClient.put('/api/v1/status-components/match-label', { match_label: matchLabel })
}

export async function getIncidentStatusComponents(incidentId: string): Promise<{ component_ids: string[]; matched_component_ids: string[] }> {
  return apiClient.get(`/api/v1/incidents/${incidentId}/status-components`)
}

export async function setIncidentStatusComponents(incidentId: string, componentIds: string[]): Promise<void> {
  await apiClient.put(`/api/v1/incidents/${incidentId}/status-components`, { component_ids: componentIds })
}
